import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PromoDangerouslyHtml } from 'components/no-auth/common/PromoDangerouslyHtml/PromoDangerouslyHtml';

import promoMedia from 'theme/promoMedia';

import { ListingTile } from './ListingTile';
import PromoPopup from '../../popup/PromoPopup';

const BottomFrame = styled.div`
    margin-top: 32px;

    ${promoMedia.tablet744} {
        margin-top: 48px;
    }

    ${promoMedia.desktop1440} {
        margin-top: 64px;
    }
`;
const PopupWrapper = styled.div`
    padding: 32px;

    ${promoMedia.tablet744} {
        padding: 48px;
    }

    ${promoMedia.desktop1440} {
        padding: 64px;
    }
`;
const ListingTileWithPopup = (props) => {
    const popupRef = useRef(null);

    return (
        <>
            {props.description !== null ? (
                <ListingTile
                    loadingLazy={props.loadingLazy}
                    img={props.img}
                    title={props.title}
                    subtitle={props.subtitle}
                    onClick={() => {
                        popupRef.current?.open(
                            <PopupWrapper popupRef={popupRef}>
                                <ListingTile img={props.img} title={props.title} subtitle={props.subtitle} />
                                <BottomFrame>
                                    {props.description && <PromoDangerouslyHtml color={'baseColor'} dangerouslyHtml={props.description} tag={'div'} />}
                                </BottomFrame>
                            </PopupWrapper>,
                        );
                    }}
                />
            ) : (
                <ListingTile
                    loadingLazy={props.loadingLazy}
                    img={props.img}
                    title={props.title}
                    subtitle={props.subtitle}
                    linkText={props.linkText}
                    linkUrl={props.linkUrl}
                />
            )}
            <PromoPopup ref={popupRef} isWidePopup />
        </>
    );
};
ListingTileWithPopup.propTypes = {
    img: PropTypes.array,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
    loadingLazy: PropTypes.bool,
};
export default ListingTileWithPopup;
